import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class EtsLeadershipUserType {
  public readonly key = 'EtsLeadershipUserType';
  public readonly enrollTrackRole = EnrollTrackRole.EtsLeadership;
}
